<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex justify-between my-3">
  <h2>Agents</h2>
  <button *appHasAnyPrivilege="'AGENT_CREATE'" nz-button nzType="primary" (click)="editNavigate()">
    Add New Agent
  </button>
</div>

<section id="agent-records">

  <nz-card>
    <div class="flex flex-col gap-3">
      <div [ngClass]="loading ? 'hidden' : 'block'">
        <nz-collapse>
          <nz-collapse-panel [nzHeader]="'Advanced Search'">
            <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
              <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton">
                  <input type="text" [(ngModel)]="searchText" nz-input placeholder="Search Agents"/>
                </nz-input-group>

                <ng-template #suffixIconSearchButton>
                  <button nz-button nzType="primary" nzSearch class="bg-[#6B6C6E] border-[#6B6C6E]" (click)="search()">
                    <span nz-icon nzType="search"></span>
                  </button>
                </ng-template>
                <nz-divider
                  class="hidden lg:block"
                  [nzType]="'vertical'"
                ></nz-divider>


              </div>

              <div>
                <button nz-button nzBlock class="outline-button" (click)="resetSearch()">
                  Reset All
                </button>
              </div>

            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>

      <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
        <div class="table-obj">
          <nz-table
            #basicTable [nzData]="agentsData" [nzShowSizeChanger]="pageSize.length > 5"
            [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
            [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
            (nzQueryParams)="onTableParamsChange($event)" nzTableLayout="fixed" [nzScroll]="{ x: 'auto', y: '550px' }"

            nzOuterBordered
          >
            <thead>
            <tr>
              <th>Agent ID</th>
              <th>Agent Name</th>
              <th>Category</th>
              <th>Contact Number</th>
              <th>Email</th>
              <th>
                <span>Created Date</span>
                <span *ngIf="sortOrder === -1" nz-icon nzType="up" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
                <span *ngIf="sortOrder === 1" nz-icon nzType="down" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span></th>
              <th *appHasAnyPrivilege="'AGENT_UPDATE'">Actions</th>

            </tr>
            </thead>
            <tbody>

            <!--        Normal Repairs entry-->
            <tr *ngFor="let data of basicTable.data" class="align-baseline">
              <td style="min-width: 100px;">
                <span>{{ data.refNo }}</span>
              </td>
              <td  style="min-width: 150px;white-space: nowrap">{{ data.name }}</td>
              <td style="min-width: 150px; white-space: nowrap">{{ data.category === 'SR_TRANSFER' ? 'SR Transfer' : 'SR Rent' }}</td>
              <td style="min-width: 150px; white-space: nowrap" class="clickable-mail-phone_no"><a class="clickable-mail-phone_no"
                                                     href="tel:{{data.contactNo}}">{{ data.contactNo }}</a></td>
              <td style="min-width: 150px; white-space: nowrap" class="clickable-mail-phone_no"><a class="clickable-mail-phone_no"
                                                     href="mailto:{{data.email}}">{{ data.email }}</a></td>
              <td style="min-width: 150px;">{{ data.createdAt | date:'yyyy-MM-dd' }}</td>
              <td style="min-width: 150px; white-space: nowrap" *appHasAnyPrivilege="'AGENT_UPDATE'">
                <button *appHasAnyPrivilege="'AGENT_UPDATE'" class="mr-3" nz-button nzType="default"
                        [class.outline-button]="!(data.name === 'Europcar' || data.name === 'Green Motion')"
                        (click)="editNavigate(this.data._id)" [disabled]="data.name === 'Europcar' || data.name === 'Green Motion'">
                  Edit
                </button>
                <button *appHasAnyPrivilege="'AGENT_UPDATE'" class="mr-3" nz-button nzType="default"
                        [class.outline-button]="!(data.name === 'Europcar' || data.name === 'Green Motion')"
                        [disabled]="data.name === 'Europcar' || data.name === 'Green Motion'"
                        nz-popconfirm
                        nzPopconfirmTitle="Are you sure delete this agent?"
                        nzCancelText="No"
                        nzOkText="Yes"
                        (nzOnConfirm)="deleteAgent(this.data._id)"
                        (nzOnCancel)="cancel()">
                  Delete
                </button>
              </td>
            </tr>

            </tbody>
          </nz-table>
        </div>
      </div>
      <div [ngClass]="loading ? 'block' : 'hidden'">
        <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
      </div>
    </div>
  </nz-card>

</section>
